export const RightSidebar = ({ config, onShortcutClick, isLocked }: any) => (
  <div className="hidden lg:flex w-[78px] bg-[#f5f7f7] border-l border-gray-200 flex-col z-0 py-2 px-1.5 gap-1.5">
    {config.sidebarShortcuts.filter((b: any) => b.shortcut !== 'F2').map((btn: any, idx: number) => btn.spacer ? (
      <div key={idx} className="flex-1" />
    ) : (
      <button
        key={idx}
        onClick={() => { if (!isLocked) onShortcutClick(btn); }}
        disabled={isLocked}
        title={isLocked ? 'Locked' : btn.tooltip}
        className={`
          flex flex-col items-center justify-center rounded-xl py-2 px-1 min-h-[48px]
          transition-all duration-200 border
          ${isLocked
            ? 'opacity-40 cursor-not-allowed border-transparent'
            : btn.active
              ? 'bg-[#1e8585] text-white border-[#1e8585] shadow-md shadow-[#1e8585]/20'
              : 'bg-white border-gray-200 hover:border-[#1e8585]/40 hover:bg-[#f0fdfa] hover:shadow-sm hover:-translate-y-[1px] active:translate-y-0 cursor-pointer'
          }
        `}
      >
        <span className={`text-[11px] font-bold leading-none ${
          btn.active && !isLocked ? 'text-white/90' : 'text-[#1e8585]'
        }`}>
          {btn.shortcut}
        </span>
        <span className={`text-[9px] text-center leading-tight mt-1 font-medium ${
          btn.active && !isLocked ? 'text-white/80' : 'text-gray-500'
        }`}>
          {btn.label}
        </span>
      </button>
    ))}
  </div>
);
